import * as React from "react";

import {FiPhoneCall} from "@react-icons/all-files/fi/FiPhoneCall";
import {GoMail} from "@react-icons/all-files/go/GoMail";
import {IoLocationSharp} from "@react-icons/all-files/io5/IoLocationSharp";
import {Trans} from "react-i18next";
import {graphql, useStaticQuery} from "gatsby";

const ContactCards: React.FC = () => {
	const {social} = useStaticQuery(
		graphql`
			query {
				social {
					company
					street
					city
					email
					phone
					facebookUrl
					githubUrl
					twitterUrl
				}
			}
		`
	);

	return (
		<div className="w-full bg-white">
			<div className="max-w-6xl mx-auto px-6 py-16">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
					<div className="bg-white shadow-md rounded-md px-6 py-8 border-b-4 border-blueish">
						<div className="flex justify-center pb-5">
							<FiPhoneCall className="text-6xl text-blueish"/>
						</div>
						<p className=" text-greygoti font-semibold pb-4 text-center capitalize text-base">
							<Trans>Phone</Trans>
						</p>
						<p className="text-metalic text-center text-base">
							{social.phone}
						</p>
					</div>
					<div className="bg-white shadow-md rounded-md px-6 py-8 border-b-4 border-blueish">
						<div className="flex justify-center pb-5">
							<GoMail className="text-6xl text-blueish"/>
						</div>
						<p className=" text-metalic font-semibold pb-4 text-center capitalize text-base">
							<Trans>Email</Trans>
						</p>
						<p className="text-metalic text-center text-base">
							{social.email}
						</p>
					</div>
					<div className="bg-white shadow-md rounded-md px-6 py-8 border-b-4 border-blueish">
						<div className="flex justify-center pb-5">
							<IoLocationSharp className="text-6xl text-blueish"/>
						</div>
						<p className=" text-metalic font-semibold pb-4 text-center capitalize text-base">
							<Trans>Address</Trans>
						</p>
						<p className=" text-metalic text-center capitalize text-sm pb-4">
							{social.company}
							<br/>
							{social.street}
							<br/>
							{social.city}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContactCards;
